<template>

  <div class="earnings-payout-box">
    <!-- <Loading v-if="report.loading" class="static" /> -->
    <div class="earnings-payout-info" v-loading="report.loading">
      <p>Last cash-out: {{ report.data.last_commission_cashout_datetime ? moment(report.data.last_commission_cashout_datetime).format('MMMM D, YYYY') : '-' }}</p>
      <ul>
        <li>
          <span>Total Commission Pending</span>
          <strong>{{ FormatMoney(report.data.total_commission_pending) }}</strong>
        </li>
        <li>
          <span>Total Commission Earnings</span>
          <strong>{{ FormatMoney(report.data.total_commission_earnings) }}</strong>
        </li>
        <li>
          <span>Total Bonus Earnings</span>
          <strong>{{ FormatMoney(report.data.total_bonus_earnings) }}</strong>
        </li>
      </ul>
    </div>


    <section class="earnings-table-wrap">
      <header>
        <h3>
          <span>Summary</span>
          <a v-if="summary.data?.length !== 0" :key="isYearly" @click="download" download="summary.csv" :data-href="`/creator/transaction-summary-by-anchor-merchants-detail?anchor_creator_id=${props.user_id}&for_download=1${isYearly ? '&summary_type=year' : ''}`"><svg-icon name="download" /></a>
        </h3>
        <el-radio-group v-model="isYearly">
          <el-radio-button :value="false">Monthly</el-radio-button>
          <el-radio-button :value="true">Yearly</el-radio-button>
        </el-radio-group>
      </header>
      <div v-if="summary.loading" style="height: 188px;" v-loading="summary.loading"></div>
      <el-table v-else-if="summary.data?.length !== 0" :data="summary.data" v-loading="summary.loading">
        <el-table-column prop="select_date" label="Date">
          <template #default="scope">
            {{ moment(scope.row.select_date).format(isYearly ? 'YYYY' : 'MMMM ‘YY') }}
          </template>
        </el-table-column>
        <el-table-column prop="merchant_account_name" label="Source" />
        <el-table-column  v-if="!isMobile" prop="sales_total" label="Sales" />
        <el-table-column prop="sale_value_total" label="Sales Value">
          <template #default="scope">
            {{ FormatMoney(scope.row.sale_value_total) }}
          </template>
        </el-table-column>
        <el-table-column prop="earnings_total" label="Earned" width="140">
          <template #default="scope">
              {{ FormatMoney(scope.row.earnings_total) }}
          </template>
        </el-table-column>
      </el-table>
      <el-button v-if="summary.data?.length !== 0 && !summary.loading" class="w-100" @click="openSide('summary')">See all</el-button>
      <NoData v-else-if="summary.data?.length === 0 && !summary.loading" title="No summary yet" />
    </section>


    <section class="earnings-table-wrap">
      <header>
        <h3>
          <span>Bonus Earnings</span>
          <a v-if="transactions.top3_rows?.length !== 0" @click="download" download="transactions.csv" :data-href="`/creator/transactions?anchor_creator_id=${props.user_id}&for_download=1`"><svg-icon name="download" /></a>
        </h3>
        <span v-if="report.pending_amount">{{ FormatMoney(report.pending_amount) }} total pending</span>
      </header>
      <div v-if="transactions.loading" style="height: 188px;" v-loading="transactions.loading"></div>
      <el-table v-else-if="transactions.top3_rows?.length !== 0" :data="transactions.top3_rows" class="product-table" @row-click="openProduct">
        <el-table-column prop="transaction_date" label="Date" :width="isMobile ? 100 : 120">
          <template #default="scope">
            {{ moment(scope.row.transaction_date).format('MMM DD, YYYY') }}
          </template>
        </el-table-column>
        <el-table-column prop="product_detail" label="Item" :width="isMobile ? 80 : 300">
          <template #default="scope">
            <div class="product-info">
              <el-image style="width: 50px; height: 50px" :src="scope.row.product_detail.images.img_200x200" fit="contain" />
              <h4>{{ scope.row.product_detail.name }}</h4>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="creator_portal_merchant_name" label="Merchant" /> -->
        <el-table-column v-if="!isMobile" prop="creator_portal_source_name" label="Source" />
        <!-- <el-table-column v-if="!isMobile" prop="sales_value" label="Sales Value">
          <template #default="scope">
            {{ FormatMoney(scope.row.sale_value) }}
          </template>
        </el-table-column> -->
        <el-table-column prop="earnings" label="Earnings" width="105">
          <template #default="scope">
            <span>{{ FormatMoney(scope.row.earnings) }}</span>
            {{ scope.row.is_payable === 1 ? 'Paid' : 'Pending' }}
          </template>
        </el-table-column>
      </el-table>
      <el-button v-if="transactions.top3_rows?.length !== 0" class="w-100"  @click="openSide('transactions')">See all</el-button>
      <NoData v-else-if="transactions.top3_rows?.length === 0 && !transactions.loading" title="No bonus earnings yet" />
    </section>
  </div>
  <EarningsSide ref="slider" @open-product="openSubProduct" :user_id="props.user_id" :FormatMoney="FormatMoney" :user_joined_date="props.user_joined_date" />
  <EarningsSide ref="sub_slider" :is_sub="true" :user_id="props.user_id" :FormatMoney="FormatMoney" :user_joined_date="props.user_joined_date" />
</template>
<script setup>
    import { ref, getCurrentInstance, onMounted, watch } from 'vue';
    // import Loading from './ui/Loading.vue';
    // import { useStore } from 'vuex';
    import moment from 'moment';
    import { ElTable, ElTableColumn, ElImage, ElRadioGroup, ElRadioButton, vLoading, ElButton } from 'element-plus';
    import NoData from '@/components/creator/NoData.vue';
    import EarningsSide from '@/components/EarningsSide.vue';

    // const store = useStore();
    const app = getCurrentInstance();
    const ajax = app.appContext.config.globalProperties.$ajax;
    const slider = ref(null);
    const sub_slider = ref(null);
    // const EventBus = app.appContext.config.globalProperties.EventBus;
    const summary = ref({
      data: [],
      type: 'month',
      loading: true
    });

    const transactions = ref({
      top3_rows: [],
      loading: true
    });

    const report = ref({
      data: {
        last_commission_cashout_datetime: null,
        total_bonus_earnings: 0,
        total_commission_earnings: 0,
        total_commission_pending: 0
      },
      loading: true
    });

    const isMobile = ref(window.innerWidth < 768);



    const isYearly = ref(false);

    const props = defineProps({
      user_id: {
        type: String,
        default: ''
      },
      motom_user_id: {
        type: String,
        default: ''
      },
      user_joined_date: {
        type: String,
        default: ''
      }
    });

    watch(isYearly, () => {
      getSummary();
    });

    const openSide = (type) => {
      slider.value.open(type);
    };

    const openProduct = (row, event, column) => {
      slider.value.open('product', row.product_detail);
    };

    const openSubProduct = (obj) => {
      sub_slider.value.open('product', obj);
    };
    const FormatMoney = (value) => {
      value = Number(value);
      return value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    };

    const getSummary = () => {
      if (props.motom_user_id) {
        summary.value.loading = true;
        ajax.get('/creator/transaction-summary-by-anchor-merchants-detail?anchor_creator_id=' + props.user_id + '&summary_type=' + (isYearly.value ? 'year' : 'month')).then((res) => {
          summary.value.data = res.data.data.data.data;
          summary.value.loading = false;
        });
      } else {
        summary.value.loading = false;
      }
    };

    const getTransactions = () => {
      if (props.motom_user_id) {
      
        transactions.value.loading = true;
        ajax.get('/creator/transactions?anchor_creator_id=' + props.user_id).then((res) => {
          transactions.value.top3_rows = res.data.data.data.top3_rows;
          transactions.value.loading = false;
        });
      } else {
        transactions.value.loading = false;
      }
    };

    const download = (e) => {
      e.preventDefault();
      
      const base = ajax.defaults.baseURL === '/api/v1' ? '' : ajax.defaults.baseURL;
      const url = base + e.target.dataset.href;
      const fileName = e.target.download;
      const a = document.createElement('a');

      ajax.get(url).then(res => {
        const blob = new Blob([res.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });

    };

    onMounted(() => {
      if (props.motom_user_id) {
        ajax.get('/creator/lifetime-earning-and-commission-by-anchor-merchants?anchor_creator_id=' + props.user_id).then((res) => {
          report.value.data = res.data.data.data;
          report.value.loading = false;
        });
      } else {
        report.value.loading = false;
      }
      getSummary();
      getTransactions();
    });
</script>
<style lang="scss">
.earnings-payout-box {
  padding: 24px 0;

  .earnings-payout-info {
    padding: 20px 24px;
    background-color: var(--White);
    border-radius: 12px;
    box-shadow: var(--bot-2dp);
    border: 1px solid var(--Black-05);
    color: var(--Black-90);

    p {
      margin-bottom: 6px;
    }

    ul {
      display: flex;
      gap: 16px;

      li {
        flex: 1;

        span {
          display: block;
          font: var(--medium-16);
          margin-bottom: 4px;
        }

        strong {
          font: var(--medium-24);
          font-weight: normal;
        }
      }
    }
  }

  .earnings-table-wrap {
    padding: 16px;
    background-color: var(--Bg-02);
    border-radius: calc(var(--radius) + 2px);
    margin: 16px 0;

    .ui-loading-mask {
      background-color: transparent;
    }

    & > header {
      display: flex;
      align-items: center;

      h3 {
        display: flex;
        align-items: center;
        flex: 1;

        span {
          font: var(--medium-20);
          color: var(--Text-primary);
        }

        a {
          height: 24px;
          width: 24px;
          cursor: pointer;
          border-radius: var(--radius);
          transition: all .2s ease;
          color: var(--Text-primary);
          margin-left: 8px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          top: 2px;

          &::before {
            content: '';
            position: absolute;
            top: 0%;
            left: 0%;
            width: 100%;
            height: 100%;
          }

          svg {
            width: 70%;
            height: 70%;
          }

          &:hover {
            color: var(--Text-brand);
          }

        }
      }

      & > span {
        color: var(--Text-secondary);
      }

      .el-radio-button:first-child .ui-radio-button__inner {
        border-color: var(--ui-color-primary);
      }

      .el-radio-button__inner {
        border-color: var(--ui-color-primary);
        padding: 0;
        width: 110px;
        height: 30px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font: var(--medium-12);
        color: var(--Text-primary);
      }

      @media screen and (max-width: $mobile_size) {
        display: block;

        h3 {
          margin-bottom: 8px;

          span {
            flex: 1;
          }
        }

        .el-radio-group {
          width: 100%;

          .el-radio-button {
            width: 50%;
          }

          .el-radio-button__inner {
            width: 100%;
          }
        }
        
      }
    }

    & > p {
      color: var(--Text-secondary);
      display: flex;
      align-items: center;

      span {
        flex: 1;
        font: var(--book-12);
      }

      .el-button {
        background-color: var(--Bg-01);

        span {
          display: flex;
          align-items: center;
          font: var(--medium-12);

          svg {
            margin-left: 4px;
            height: 14px;
            width: 14px;
            cursor: pointer;
          }
        }
      }
    }

    .w-100 {
      width: 100%;
    }

    .status-rejected {
      font: var(--medium-12);
      color: var(--Red-30);
    }

    .status-completed {
      font: var(--medium-12);
      color: var(--Green-30);
    }

    .status-processing {
      font: var(--medium-12);
      color: var(--Blue-30);
    }

    .product-info {
      display: flex;
      gap: 8px;
    }

    .product-table {
      tbody tr {
        cursor: pointer;
      }
    }

  }
}

</style>
